import React, { useState } from 'react'
import Image from 'next/image'
import { Card, Col, Container, Row } from 'react-bootstrap'
import OurJourneyImg from '@/assets/about-us/our-journey-1.webp'

const data = [
	{
		id: 1,
		month: 'December',
		year: 2020,
		title: 'Metalbook',
		subtitle: 'Incorporated',
		discription:
			'Metalbook was incorporated in the month of December 2020 with RP Singh, Aman Tibrewal & Pulkit Baldev as its Co-founders and Gurgaon as its headquarters.',
	},
	{
		id: 2,
		month: 'March',
		year: 2022,
		title: '$23 Million',
		subtitle: 'Achieved ARR',
		discription:
			'Metalbook Achieved an ARR of $23 Million in the Month of March 2022 from its E-Com business arm with a sales-supply team strength of just 15 people.',
	},
	{
		id: 3,
		month: 'October',
		year: 2022,
		title: 'Cloud Factory, Recycling',
		subtitle: 'Launched',
		discription:
			'New business verticals - Cloud Factory, Metal Recycling were launched in the month of October 2022 which helped Metalbook cater to Metal customisation for various clients and work towards sustainability through Metal Recycling.',
	},

	{
		id: 4,
		month: 'June',
		year: 2023,
		title: 'Series A',
		subtitle: 'Raised',
		discription: 'Metalbook raised $10M in Series A round - led by Rigel Capital and supported by FJ Labs, Foundamental and Axilor.',
	},
	{
		id: 5,
		month: 'December',
		year: 2023,
		title: 'Non Ferrous',
		subtitle: 'Launched',
		discription: 'Metalbook entered into the Non-ferrous commodity and Mineral space eg. Copper, Aluminium, Zinc etc. in December 2023’.',
	},
	{
		id: 6,
		month: 'March',
		year: 2024,
		title: '$190 Million',
		subtitle: 'Achieved ARR',
		discription:
			'Metalbook Achieved an ARR of $190 Million in the Month of March 2024 from all it’s business Arms : E-com, CF, Metal Recycling, Non-ferrous, Exports.',
	},
	{
		id: 7,
		month: 'May',
		year: 2024,
		title: 'MbookPlus',
		subtitle: 'Launched',
		discription:
			'We launched MbookPlus - India’s 1st Supply chain Financing Marketplace for Metal Industry. Onboarded 3rd party lenders like Stride, Capsave, Credible on the platform.',
	},
]

const revenueData = [
	{ title: '205%', description: 'CAGR FY22 - FY24' },
	{ title: '650k+', description: 'Total Enquiries recorded (in MT)' },
	{ title: '4500+', description: 'Total Stakeholders Connected' },
	{ title: '1000+', description: 'Total SKUs Served' },
	{ title: '10+', description: 'Partner ScrapYards' },
	{ title: '37+', description: 'Cloud Factories Onboarded' },
]

const OurJourney = () => {
	const [activeContent, setActiveContent] = useState(1)
	const selectedData = data?.find((item) => item?.id === activeContent)
	return (
		<div className='our-journey-container p-sm-5'>
			<h2 className='heading'>Our Journey</h2>
			<div className='our-journey-background'>
				<Container>
					<Row className='our-journey-content-wapper'>
						<Col xs={12} md={12} lg={5}>
							<div style={{ height: '370px' }}>
								<div>
									<h2>{selectedData?.month}</h2>
								</div>
								<div>
									<h1 className='year-item'>{selectedData?.year}</h1>
								</div>
								<div className='our-journey-content'>
									<p>{selectedData?.discription}</p>
								</div>
							</div>
						</Col>
						<Col xs={12} md={12} lg={6}>
							<Image src={OurJourneyImg} alt='..' />
						</Col>
					</Row>
				</Container>
				<Row className='m-0'>
					<Col lg={12} className='scroll-tab' style={{ flex: 1 }}>
						<div className='our-journey-item-wapper' style={{ flex: 1 }}>
							{data?.map((item, index) => (
								<div
									className='our-journey-item cursor-pointer'
									key={`our-journey-item"-${index}`}
									onMouseEnter={() => setActiveContent(item?.id)}
								>
									<span>{item?.month}</span>
									<p>{item?.year}</p>
									<hr className={`${activeContent === item?.id ? 'bg-secondary bg-gradient' : ''}`} />
									<h6>{item?.subtitle}</h6>
									<h5>{item?.title}</h5>
								</div>
							))}
						</div>
					</Col>
				</Row>
			</div>
			{/* <Container className='mt-5 mb-stats shadow-lg mx-0'> */}
			<Row className='mt-5 shadow-lg'>
				{/* <h1 className='heading text-center mb-5'>Metalbook in Numbers</h1> */}

				{revenueData?.map((item, index) => (
					<Col xs={6} md={6} lg={4} key={`${index}`} className='investors-list-wapper d-flex'>
						<div className='investors-price investors-list-card'>
							<Card className='border-0 rounded-4'>
								<Card.Header className='border-0 bg-transparent'>
									<h2 className='primary-text'>{item?.title}</h2>
								</Card.Header>
								<Card.Body className='pt-0'>
									<p>{item?.description}</p>
								</Card.Body>
							</Card>
						</div>
					</Col>
				))}
			</Row>
			{/* </Container> */}
			{/* </div> */}
		</div>
	)
}

export default OurJourney
